export default `<div class=WordSection1 style='layout-grid:15.6pt'>

      <p class=MsoNormal align=center style='margin-bottom:7.8pt;text-align:center'><b><span
        lang=ZH-CN style='font-size:12.0pt;font-family:SimSun'>哔哩哔哩开放平台隐私政策</span></b></p>

      <p class=MsoNormal align=center style='margin-bottom:7.8pt;text-align:center'><b><span
        lang=EN-US style='font-size:12.0pt;font-family:"Times New Roman",serif'>&nbsp;</span></b></p>

      <p class=MsoNormal style='margin-bottom:0.8pt'><span lang=ZH-CN
                                                           style='font-size:12.0pt;font-family:SimSun;color:#333333'>更新日期：</span><span
        lang=EN-US style='font-size:12.0pt;font-family:"Times New Roman",serif;
color:#333333'>2021</span><span lang=ZH-CN style='font-size:12.0pt;font-family:
SimSun;color:#333333'>年</span><span lang=EN-US style='font-size:12.0pt;
font-family:"Times New Roman",serif;color:#333333'>【09】</span><span lang=ZH-CN
                                                                 style='font-size:12.0pt;font-family:SimSun;color:#333333'>月</span><span
        lang=EN-US style='font-size:12.0pt;font-family:"Times New Roman",serif;
color:#333333'>【15】</span><span lang=ZH-CN style='font-size:12.0pt;font-family:
SimSun;color:#333333'>日</span></p>

<p class=MsoNormal style='margin-bottom:20.8pt'><span lang=ZH-CN
                                                           style='font-size:12.0pt;font-family:SimSun;color:#333333'>生效日期：</span><span
        lang=EN-US style='font-size:12.0pt;font-family:"Times New Roman",serif;
color:#333333'>2021</span><span lang=ZH-CN style='font-size:12.0pt;font-family:
SimSun;color:#333333'>年</span><span lang=EN-US style='font-size:12.0pt;
font-family:"Times New Roman",serif;color:#333333'>【09】</span><span lang=ZH-CN
                                                                 style='font-size:12.0pt;font-family:SimSun;color:#333333'>月</span><span
        lang=EN-US style='font-size:12.0pt;font-family:"Times New Roman",serif;
color:#333333'>【22】</span><span lang=ZH-CN style='font-size:12.0pt;font-family:
SimSun;color:#333333'>日</span></p>

      <p class=MsoNormal style='margin-bottom:7.8pt'><span lang=EN-US
                                                           style='font-size:12.0pt;font-family:"Times New Roman",serif'>&nbsp;</span>
      </p>

      <p class=MsoNormal style='margin-bottom:7.8pt'><span lang=ZH-CN
                                                           style='font-size:12.0pt;font-family:SimSun'>欢迎您使用哔哩哔哩开放平台服务！</span>
      </p>

      <p class=MsoNormal style='margin-bottom:7.8pt;text-indent:24.0pt'><span
        lang=ZH-CN style='font-size:12.0pt;font-family:SimSun'>哔哩哔哩开放平台（以下简称“开放平台”）非常重视用户的隐私，我们希望通过本隐私政策，向</span><span
        lang=EN-US style='font-size:12.0pt;font-family:"Times New Roman",serif'>“</span><b><span
        lang=ZH-CN style='font-size:12.0pt;font-family:SimSun'>使用哔哩哔哩开放平台的开发者、UP主（以下合称“您”）就开放平台中的各项服务（以下简称“本服务”）</span></b><span
        lang=EN-US style='font-size:12.0pt;font-family:"Times New Roman",serif'>”</span><span
        lang=ZH-CN style='font-size:12.0pt;font-family:SimSun'>如何收集、使用、储存、分享和删除您的个人信息所做的说明。</span></p>

      <p class=MsoNormal style='margin-bottom:7.8pt;text-indent:24.0pt'><span
        lang=EN-US style='font-size:12.0pt;font-family:"Times New Roman",serif'><b>您在使用本服务前，请务必仔细阅读并充分理解本隐私政策，当您通过勾选、点击确认、同意授权或其他方式确认本隐私政策，或在收到本隐私政策的更新通知后（包括在显著位置提示或推送通知、消息等形式）继续使用本服务的，即表示您已同意我们按照本隐私政策合法使用和保护您的个人信息。</b></span>
      </p>

      <p class=MsoNormal style='margin-bottom:7.8pt;text-indent:24.0pt'><span
        lang=EN-US style='font-size:12.0pt;font-family:"Times New Roman",serif'><b>您需理解，只有在您确认并同意变更后的《哔哩哔哩开放平台隐私政策》，我们才会依据变更后的隐私政策收集、使用、处理和存储您的个人信息；您有权拒绝同意变更后的隐私政策，但请您知悉，一旦您拒绝同意变更后的隐私政策，可能导致您不能或不能继续完整使用本服务，或者无法达到我们拟达到的服务效果。</b></span>
      </p>

            <!-- <p class=ListParagraph1 style='margin-top:0cm;margin-right:0cm;margin-bottom:
7.8pt;margin-left:21.0pt;text-indent:-21.0pt'><b><span lang=ZH-CN style='font-size:12.0pt;font-family:SimSun'>《哔哩哔哩开放平台隐私政策》目录</span></b></p>
 -->



      <p class=ListParagraph1 style='margin-top:0cm;margin-right:0cm;margin-bottom:
7.8pt;margin-left:21.0pt;text-indent:-21.0pt'><b><span lang=EN-US
                                                       style='font-size:12.0pt;font-family:"Times New Roman",serif'>一、<span
        style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
</span></span></b><b><span lang=ZH-CN style='font-size:12.0pt;font-family:SimSun'>关于我们</span></b></p>

      <p class=ListParagraph1 style='margin-top:0cm;margin-right:0cm;margin-bottom:
7.8pt;margin-left:21.0pt;text-indent:-21.0pt'><span lang=EN-US
                                                    style='font-size:12.0pt;font-family:"Times New Roman",serif'>1.<span
        style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; </span></span><span
        lang=ZH-CN style='font-size:12.0pt;font-family:SimSun;color:black;background:
white'>本服务由上海宽娱数码科技有限公司（以下称“上海宽娱”）及其关联公司提供。</span></p>

<p class=ListParagraph1 style='margin-top:0cm;margin-right:0cm;margin-bottom:
7.8pt;margin-left:21.0pt;text-indent:-21.0pt'><span lang=EN-US
                                                    style='font-size:12.0pt;font-family:"Times New Roman",serif'>2.<span
        style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; </span></span><span
        lang=ZH-CN style='font-size:12.0pt;font-family:SimSun;color:black;background:
white'>关联公司是指在现在、将来控制上海宽娱数码科技有限公司、受上海宽娱数码科技有限公司控制或与上海宽娱数码科技有限公司处于共同控制下的公司、机构。控制指通过所有权、有投票权的股份、合同、实际运营关联或其他被依法认定的方式直接或间接地拥有影响被控制对象管理/经营的能力。</span></p>

<p class=ListParagraph1 style='margin-top:0cm;margin-right:0cm;margin-bottom:
7.8pt;margin-left:21.0pt;text-indent:-21.0pt'><span lang=EN-US
                                                    style='font-size:12.0pt;font-family:"Times New Roman",serif'>3.<span
        style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; </span></span><span
        lang=ZH-CN style='font-size:12.0pt;font-family:SimSun;color:black;background:
white'>我们的主要运营主体的基本信息如下：上海宽娱数码科技有限公司，成立于2005年8月12日，联系电话为021-25099888，注册地址为上海市杨浦区政立路489号801室，常用办公地址为上海市杨浦区政立路485号国正中心3号楼。/经营的能力。</span></p>

      <p class=ListParagraph1 style='margin-top:0cm;margin-right:0cm;margin-bottom:
7.8pt;margin-left:21.0pt;text-indent:0cm'><span lang=EN-US style='font-size:
12.0pt;font-family:"Times New Roman",serif;background:white'>&nbsp;</span></p>

      <p class=ListParagraph1 style='margin-top:0cm;margin-right:0cm;margin-bottom:
7.8pt;margin-left:21.0pt;text-indent:-21.0pt'><b><span lang=EN-US
                                                       style='font-size:12.0pt;font-family:"Times New Roman",serif'>二、<span
        style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
</span></span></b><b><span lang=ZH-CN style='font-size:12.0pt;font-family:SimSun'>我们如何收集、使用和披露UP主的个人信息</span></b></p>

      <p class=ListParagraph1 style='margin-top:0cm;margin-right:0cm;margin-bottom:
7.8pt;margin-left:21.0pt;text-indent:-21.0pt'><span lang=EN-US
                                                    style='font-size:12.0pt;font-family:"Times New Roman",serif'>1.<span
        style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; </span></span><span
        lang=ZH-CN style='font-size:12.0pt;font-family:SimSun'>哔哩哔哩依据法律法规、
        <a
        href="https://www.bilibili.com/blackboard/privacy-pc.html"><span lang=ZH-CN
        style='font-family:SimSun'>《哔哩哔哩隐私政策》</span></a><span>以及遵循正当、合法、必要的原则，收集和使用您在使用哔哩哔哩服务过程中主动提供或由于产品和/或服务需要而产生的个人信息。</span>
        </span>
      </p>

      <p class=ListParagraph1 style='margin-top:0cm;margin-right:0cm;margin-bottom:
7.8pt;margin-left:21.0pt;text-indent:-21.0pt'><span lang=EN-US
                                                    style='font-size:12.0pt;font-family:"Times New Roman",serif'>2.<span
        style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; </span></span><span
        lang=ZH-CN
        style='font-size:12.0pt;font-family:SimSun'>如您使用本服务，我们将根据服务类型，经您的授权后向开发者披露您的个人信息，服务类型包括两种：</span><b>（1）本服务的核心业务功能所必需的信息：此类信息为本服务核心业务功能的必备信息，如您拒绝向开发者披露，您将无法正常使用本服务；（2）附加业务功能所必需的信息：此信息为非核心业务功能所需的信息，您可以选择是否授权我们向特定开发者披露。如您拒绝披露，将导致附加业务功能无法实现或无法达到我们拟达到的效果，但不影响您对核心业务功能的正常使用。</b></p>

       <p class=ListParagraph1 style='margin-top:0cm;margin-right:0cm;margin-bottom:
7.8pt;margin-left:21.0pt;text-indent:-21.0pt'><span lang=EN-US
                                                    style='font-size:12.0pt;font-family:"Times New Roman",serif'>3.<span
        style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; </span></span><span
        lang=ZH-CN
        style='font-size:12.0pt;font-family:SimSun'>我们会在以下业务功能中披露UP主的个人信息：</span></p>

        <p class=ListParagraph1 style='margin-top:0cm;margin-right:0cm;margin-bottom:
7.8pt;margin-left:21.0pt;text-indent:-21.0pt'><span lang=EN-US
                                                    style='font-size:12.0pt;font-family:"Times New Roman",serif'>3.1<span
        style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; </span></span><span
        lang=ZH-CN
        style='font-size:12.0pt;font-family:SimSun'>关联开发者</span></p>

        <p class=ListParagraph1 style='margin-top:0cm;margin-right:0cm;margin-bottom:
7.8pt;margin-left:21.0pt;text-indent:-21.0pt'><span lang=EN-US
                                                    style='font-size:12.0pt;font-family:"Times New Roman",serif'>（1）<span
        style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; </span></span><b>您首次关联开发者时，我们需要向您关联的开发者披露您的账号基础信息，包括：账号昵称、头像、OpenID。同时，关联开发者将获得您账号项下的稿件管理能力，以帮助您编辑、发布、删除稿件。</b><span
        lang=ZH-CN
        style='font-size:12.0pt;font-family:SimSun'>开放平台只有向开发者提供上述信息以及权限后才能关联您的账号并提供本服务的核心业务功能。如果您选择不披露上述信息或许可上述权限，将导致开放平台和/或开发者无法为您提供开放平台的核心业务功能。</span></p>


        <p class=ListParagraph1 style='margin-top:0cm;margin-right:0cm;margin-bottom:
7.8pt;margin-left:21.0pt;text-indent:-21.0pt'><span lang=EN-US
                                                    style='font-size:12.0pt;font-family:"Times New Roman",serif'>（2）<span
        style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; </span></span><span
        lang=ZH-CN
        style='font-size:12.0pt;font-family:SimSun'>您可以随时通过本服务的相关功能设置页面开启/取消该权限。哔哩哔哩APP的开发者权限设置路径为</span><b>【我的—设置—安全隐私—授权管理】</b><span>您开启该权限即视为您授权我们可以向开发者披露您的该等个人信息以及开放该等权限；但当您取消该授权后，我们将不再向开发者披露上述信息或开放上述权限，也无法再为您提供上述与之对应的服务；但除非您依照法律的规定删除了您的个人信息，否则您的取消行为不会影响我们基于您之前的授权进行的您个人信息的处理。</span></p>


         <p class=ListParagraph1 style='margin-top:0cm;margin-right:0cm;margin-bottom:
7.8pt;margin-left:21.0pt;text-indent:-21.0pt'><span lang=EN-US
                                                    style='font-size:12.0pt;font-family:"Times New Roman",serif'>3.2<span
        style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; </span></span><span
        lang=ZH-CN
        style='font-size:12.0pt;font-family:SimSun'>投稿效果管理</span></p>
      
<p class=ListParagraph1 style='margin-top:0cm;margin-right:0cm;margin-bottom:
7.8pt;margin-left:21.0pt;text-indent:-21.0pt'><b>当您使用投稿效果管理服务时，我们会向关联开发者披露您的用户数据，包括：关注数、粉丝数、投稿数、获赞数。</b><span
        lang=ZH-CN
        style='font-size:12.0pt;font-family:SimSun'>您可以随时通过本服务的相关功能设置页面开启/取消该权限。哔哩哔哩APP的开发者权限设置路径为</span><b>【我的—设置—安全隐私—授权管理】</b><span>。您开启该权限即视为您授权我们可以向开发者披露您的该等个人信息；但当您取消该授权后，我们将不再向开发者披露上述信息，也无法再为您提供上述与之对应的服务；但除非您依照法律的规定删除了您的个人信息，否则您的取消行为不会影响我们基于您之前的授权进行的您个人信息的处理。</span></p>


<p class=ListParagraph1 style='margin-top:0cm;margin-right:0cm;margin-bottom:
7.8pt;margin-left:21.0pt;text-indent:-21.0pt'><span lang=EN-US
                                                    style='font-size:12.0pt;font-family:"Times New Roman",serif'>3.3<span
        style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; </span></span><span
        lang=ZH-CN
        style='font-size:12.0pt;font-family:SimSun'>稿件数据管理</span></p>


<p class=ListParagraph1 style='margin-top:0cm;margin-right:0cm;margin-bottom:
7.8pt;margin-left:21.0pt;text-indent:-21.0pt'><b>当您使用稿件数据管理服务时，我们会向关联开发者披露您的稿件数据，包括：标题、发布时间、播放数、点赞数、评论数、硬币数、充电数、收藏数、弹幕数、分享数。</b><span
        lang=ZH-CN
        style='font-size:12.0pt;font-family:SimSun'>您可以随时通过本服务的相关功能设置页面开启/取消该权限。哔哩哔哩APP的开发者权限设置路径为</span><b>【我的—设置—安全隐私—授权管理】</b><span>.您开启该权限即视为您授权我们可以向开发者披露您的该等个人信息；但当您取消该授权后，我们将不再向开发者披露上述信息，也无法再为您提供上述与之对应的服务；但除非您依照法律的规定删除了您的个人信息，否则您的取消行为不会影响我们基于您之前的授权进行的您个人信息的处理。</span></p>


<p class=ListParagraph1 style='margin-top:0cm;margin-right:0cm;margin-bottom:
7.8pt;margin-left:21.0pt;text-indent:-21.0pt'><span lang=EN-US
                                                    style='font-size:12.0pt;font-family:"Times New Roman",serif'>3.4<span
        style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; </span></span><span
        lang=ZH-CN
        style='font-size:12.0pt;font-family:SimSun'>出于其他合理且必要的目的</span></p>

        <p class=ListParagraph1 style='margin-top:0cm;margin-right:0cm;margin-bottom:
7.8pt;margin-left:21.0pt;text-indent:-21.0pt'><span lang=EN-US
                                                    style='font-size:12.0pt;font-family:"Times New Roman",serif'>（1）<span
        style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; </span></span><b>我们希望提供给您的服务是完善的，所以我们会不断改进我们的产品和技术，这意味着本服务可能会经常推出新的业务功能，可能需要收集、使用或披露新的个人信息或变更个人信息使用目的或方式。如果本服务中某一需要收集、使用或披露您的个人信息的功能或产品/服务未能在本隐私政策中予以说明的，我们会通过更新本隐私政策、页面提示、弹窗、平台公告等方式另行向您说明该信息收集、使用或披露的目的、内容、使用方式和范围，并为您提供自主选择同意的方式，且在征得您明示同意后收集。</b><span>在此过程中，如果您对相关事宜有任何疑惑的，可以通过本隐私政策第八条提供的方式联系我们，我们会尽快为您作出解答。</span></p>

        <p class=ListParagraph1 style='margin-top:0cm;margin-right:0cm;margin-bottom:
7.8pt;margin-left:21.0pt;text-indent:-21.0pt'><span lang=EN-US
                                                    style='font-size:12.0pt;font-family:"Times New Roman",serif'>（2）<span
        style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; </span></span><b>您理解并同意，在以下情况下，我们无需取得您的授权同意即可收集、使用和披露您的个人信息：</b></p>

        <p class=ListParagraph1 style='margin-top:0cm;margin-right:0cm;margin-bottom:
7.8pt;margin-left:50.0pt;text-indent:-21.0pt'><span lang=EN-US
                                                    style='font-size:12.0pt;font-family:"Times New Roman",serif'>a）<span
        style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; </span></span>与国家安全、国防安全有关的；</p>
        <p class=ListParagraph1 style='margin-top:0cm;margin-right:0cm;margin-bottom:
7.8pt;margin-left:50.0pt;text-indent:-21.0pt'><span lang=EN-US
                                                    style='font-size:12.0pt;font-family:"Times New Roman",serif'>b）<span
        style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; </span></span>与公共安全、公共卫生、重大公共利益有关的；</p>

        <p class=ListParagraph1 style='margin-top:0cm;margin-right:0cm;margin-bottom:
7.8pt;margin-left:50.0pt;text-indent:-21.0pt'><span lang=EN-US
                                                    style='font-size:12.0pt;font-family:"Times New Roman",serif'>c）<span
        style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; </span></span>与犯罪侦查、起诉、审判和判决执行等直接相关的；</p>
        <p class=ListParagraph1 style='margin-top:0cm;margin-right:0cm;margin-bottom:
7.8pt;margin-left:50.0pt;text-indent:-21.0pt'><span lang=EN-US
                                                    style='font-size:12.0pt;font-family:"Times New Roman",serif'>d）<span
        style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; </span></span>出于维护您或其他个人的生命、财产等重大合法权益但又很难得到您本人同意的；</p>
        <p class=ListParagraph1 style='margin-top:0cm;margin-right:0cm;margin-bottom:
7.8pt;margin-left:50.0pt;text-indent:-21.0pt'><span lang=EN-US
                                                    style='font-size:12.0pt;font-family:"Times New Roman",serif'>e）<span
        style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; </span></span>所收集的信息是您自行向社会公开的或者是从合法公开的渠道（如合法的新闻报道、政府信息公开等渠道）中收集到的；</p>
        <p class=ListParagraph1 style='margin-top:0cm;margin-right:0cm;margin-bottom:
7.8pt;margin-left:50.0pt;text-indent:-21.0pt'><span lang=EN-US
                                                    style='font-size:12.0pt;font-family:"Times New Roman",serif'>f）<span
        style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; </span></span>根据与您签订和履行相关协议或其他书面文件所必需的；</p>
        <p class=ListParagraph1 style='margin-top:0cm;margin-right:0cm;margin-bottom:
7.8pt;margin-left:50.0pt;text-indent:-21.0pt'><span lang=EN-US
                                                    style='font-size:12.0pt;font-family:"Times New Roman",serif'>g）<span
        style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; </span></span>用于维护我们的产品与/或服务的安全稳定运行所必需的，例如发现、处置产品与/或服务的故障；</p>
        <p class=ListParagraph1 style='margin-top:0cm;margin-right:0cm;margin-bottom:
7.8pt;margin-left:50.0pt;text-indent:-21.0pt'><span lang=EN-US
                                                    style='font-size:12.0pt;font-family:"Times New Roman",serif'>h）<span
        style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; </span></span>有权机关的要求、法律法规等规定的其他情形。</p>

      <p class=ListParagraph1 style='margin-top:0cm;margin-right:0cm;margin-bottom:
7.8pt;margin-left:21.0pt;text-indent:-21.0pt'><b><span lang=EN-US
                                                       style='font-size:12.0pt;font-family:"Times New Roman",serif'>三、<span
        style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
</span></span></b><b><span lang=ZH-CN style='font-size:12.0pt;font-family:SimSun'>我们如何收集、使用和披露开发者信息</span></b></p>

      <p class=ListParagraph1 style='margin-top:0cm;margin-right:0cm;margin-bottom:
7.8pt;margin-left:21.0pt;text-indent:-21.0pt'><span lang=EN-US
                                                    style='font-size:12.0pt;font-family:"Times New Roman",serif'>1.<span
        style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; </span></span><span
        lang=ZH-CN style='font-size:12.0pt;font-family:SimSun'>哔哩哔哩依据法律法规、<a href="/agreement/developer-service">《哔哩哔哩开放平台开发者服务协议》</a>以及遵循正当、合法、必要的原则，收集、使用并向关联UP主披露您在使用本服务过程中主动提供或由于产品和/或服务需要而产生的信息。</span>

      <p class=ListParagraph1 style='margin-top:0cm;margin-right:0cm;margin-bottom:
7.8pt;margin-left:21.0pt;text-indent:-21.0pt'><span lang=EN-US
                                                    style='font-size:12.0pt;font-family:"Times New Roman",serif'>2.<span
        style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; </span></span><span
        lang=EN-US style='font-size:12.0pt;font-family:"Times New Roman",serif'>通常情况下，我们会在以下场景中收集、使用和披露开发者信息：</span><span
        lang=ZH-CN style='font-size:12.0pt;font-family:SimSun'>主确认同意关联后，哔哩哔哩将在相关页面展示您与关联</span>
      </p>

      <p class=ListParagraph1 style='margin-top:0cm;margin-right:0cm;margin-bottom:
7.8pt;margin-left:21.0pt;text-indent:-21.0pt'><span lang=EN-US
                                                    style='font-size:12.0pt;font-family:"Times New Roman",serif'>2.1<span
        style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; </span></span><span
        lang=ZH-CN
        style='font-size:12.0pt;font-family:SimSun'>注册与登录开发者账号</span></p>

        <p class=ListParagraph1 style='margin-top:0cm;margin-right:0cm;margin-bottom:
7.8pt;margin-left:21.0pt;text-indent:-21.0pt'><span lang=EN-US
                                                    style='font-size:12.0pt;font-family:"Times New Roman",serif'>（1）<span
        style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; </span></span>申请入驻哔哩哔哩开放平台的自然人、法人或其他组织（以下简称“申请人”），需要按照我们的指引完成开发者账号的注册程序，在此过程中，申请人需要向我们提供以下信息：<b>公司名称、统一社会信用代码、公司地址、公司简介、联系人姓名、联系人身份证号码、联系邮箱、联系手机（个人敏感信息）、营业执照、申请公函。</b>申请人只有提供真实准确的上述信息，才能成功注册开发者账号并使用开放平台的核心功能。如果申请人选择不提供上述为实现开放平台核心功能的必备信息，或将导致我们无法提供该核心功能。<span
        lang=ZH-CN
        style='font-size:12.0pt;font-family:SimSun'></span></p>

        <p class=ListParagraph1 style='margin-top:0cm;margin-right:0cm;margin-bottom:
7.8pt;margin-left:21.0pt;text-indent:-21.0pt'><span lang=EN-US
                                                    style='font-size:12.0pt;font-family:"Times New Roman",serif'>（2）<span
        style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; </span></span><b>同时，开发者需理解，手机号码和电子邮箱地址属于个人敏感信息，我们收集该类信息是基于法律法规的相关要求，如拒绝提供可能导致申请人无法注册开发者账号并使用本服务，请谨慎考虑后再选择是否提供。</b><span
        lang=ZH-CN
        style='font-size:12.0pt;font-family:SimSun'></span></p>

      <p class=ListParagraph1 style='margin-top:0cm;margin-right:0cm;margin-bottom:
7.8pt;margin-left:21.0pt;text-indent:-21.0pt'><span lang=EN-US
                                                    style='font-size:12.0pt;font-family:"Times New Roman",serif'>2.2<span
        style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; </span></span><span
        lang=ZH-CN
        style='font-size:12.0pt;font-family:SimSun'>关联应用</span></p>


      <p class=ListParagraph1 style='margin-top:0cm;margin-right:0cm;margin-bottom:
7.8pt;margin-left:21.0pt;text-indent:0cm'><b><span lang=EN-US style='font-size:
12.0pt;font-family:"Times New Roman",serif'>&nbsp;开发者在正式使用本服务前，需要按照我们的指引完成关联应用的绑定程序，在此过程中，<b>开发者需要向我们提供以下信息：关联应用名称、应用网址、应用简介、应用图标，至少一个iOS或Android平台的平台信息，包括：iOS应用Bundle ID、Android应用的应用包名、应用签名，管理者信息，包括：联系人、联系邮箱、联系手机。</b>开发者只有提供真实准确的上述信息，才能成功绑定关联应用并使用开放平台的核心功能。如果开发者选择不提供上述为实现开放平台核心功能的必备信息，或将导致我们无法提供该核心功能。</span></b></p>


<p class=ListParagraph1 style='margin-top:0cm;margin-right:0cm;margin-bottom:
7.8pt;margin-left:21.0pt;text-indent:-21.0pt'><span lang=EN-US
                                                    style='font-size:12.0pt;font-family:"Times New Roman",serif'>2.3<span
        style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; </span></span><span
        lang=ZH-CN
        style='font-size:12.0pt;font-family:SimSun'>关联UP主</span></p>


      <p class=ListParagraph1 style='margin-top:0cm;margin-right:0cm;margin-bottom:
7.8pt;margin-left:21.0pt;text-indent:0cm'><b><span lang=EN-US style='font-size:
12.0pt;font-family:"Times New Roman",serif'>&nbsp;<b>当开发者首次关联UP主并提供稿件管理服务时，我们会向关联UP主披露开发者的必要数据，包括：关联应用名称、图标。</b>开发者只有允许向关联UP主披露上述信息才能成功绑定关联UP主并使用开放平台的核心功能。如果开发者选择不提供上述为实现开放平台核心功能的必备信息，或将导致我们无法提供该核心功能。</span></b></p>

<p class=ListParagraph1 style='margin-top:0cm;margin-right:0cm;margin-bottom:
7.8pt;margin-left:21.0pt;text-indent:-21.0pt'><span lang=EN-US
                                                    style='font-size:12.0pt;font-family:"Times New Roman",serif'>2.4<span
        style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; </span></span><span
        lang=ZH-CN
        style='font-size:12.0pt;font-family:SimSun'>客户服务</span></p>


      <p class=ListParagraph1 style='margin-top:0cm;margin-right:0cm;margin-bottom:
7.8pt;margin-left:21.0pt;text-indent:0cm'><b><span lang=EN-US style='font-size:
12.0pt;font-family:"Times New Roman",serif'>&nbsp;当您向开放平台发起投诉、申诉或进行咨询时，为了您的账号与系统安全，我们可能需要您先行提供账号信息，并与您之前的信息相匹配以验证您的开发者身份。<b>同时，为了方便与您联系或帮助您解决问题，我们可能还需要您提供联系人姓名、手机号码、电子邮件及其他联系方式等个人信息（个人敏感信息）。</b>
</span></b></p>
<p class=ListParagraph1 style='margin-top:0cm;margin-right:0cm;margin-bottom:
7.8pt;margin-left:21.0pt;text-indent:0cm'><b><span lang=EN-US style='font-size:
12.0pt;font-family:"Times New Roman",serif'>&nbsp;<b>另外，我们还会收集您与我们的沟通信息（包括文字/图片/音视频/通话记录形式）、与您的需求相关联的其他必要信息。</b>我们收集这些信息是为了调查事实与帮助您解决问题，如您拒绝提供上述信息，我们可能无法向您及时反馈投诉、申诉或咨询结果。
</span></b></p>

      <p class=ListParagraph1 style='margin-top:0cm;margin-right:0cm;margin-bottom:
7.8pt;margin-left:21.0pt;text-indent:-21.0pt'><span lang=EN-US
                                                    style='font-size:12.0pt;font-family:"Times New Roman",serif'>2.5<span
        style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; </span></span><span
        lang=ZH-CN
        style='font-size:12.0pt;font-family:SimSun'>注册与登录开发者账号</span></p>

        <p class=ListParagraph1 style='margin-top:0cm;margin-right:0cm;margin-bottom:
7.8pt;margin-left:21.0pt;text-indent:-21.0pt'><span lang=EN-US
                                                    style='font-size:12.0pt;font-family:"Times New Roman",serif'>（1）<span
        style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; </span></span><b>我们希望提供给您的服务是完善的，所以我们会不断改进我们的产品和技术，这意味着本服务可能会经常推出新的业务功能，可能需要收集、使用或披露新的开发者信息或变更开发者信息使用目的或方式。如果本服务中某一需要收集、使用或披露开发者信息的功能或产品/服务未能在本隐私政策中予以说明的，我们会通过更新本隐私政策、页面提示、弹窗、平台公告等方式另行向您说明该信息收集、使用或披露的目的、内容、使用方式和范围，并为您提供自主选择同意的方式，且在征得您明示同意后收集。</b>在此过程中，如果您对相关事宜有任何疑惑的，可以通过本隐私政策第八条提供的方式联系我们，我们会尽快为您作出解答。<span
        lang=ZH-CN
        style='font-size:12.0pt;font-family:SimSun'></span></p>
         <p class=ListParagraph1 style='margin-top:0cm;margin-right:0cm;margin-bottom:
7.8pt;margin-left:21.0pt;text-indent:-21.0pt'><span lang=EN-US
                                                    style='font-size:12.0pt;font-family:"Times New Roman",serif'>（2）<span
        style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; </span></span><b>您理解并同意，在以下情况下，我们无需取得您的授权同意即可收集、使用和披露您的个人信息：</b></p>

        <p class=ListParagraph1 style='margin-top:0cm;margin-right:0cm;margin-bottom:
7.8pt;margin-left:50.0pt;text-indent:-21.0pt'><span lang=EN-US
                                                    style='font-size:12.0pt;font-family:"Times New Roman",serif'>a）<span
        style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; </span></span>与国家安全、国防安全有关的；</p>
        <p class=ListParagraph1 style='margin-top:0cm;margin-right:0cm;margin-bottom:
7.8pt;margin-left:50.0pt;text-indent:-21.0pt'><span lang=EN-US
                                                    style='font-size:12.0pt;font-family:"Times New Roman",serif'>b）<span
        style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; </span></span>与公共安全、公共卫生、重大公共利益有关的；</p>

        <p class=ListParagraph1 style='margin-top:0cm;margin-right:0cm;margin-bottom:
7.8pt;margin-left:50.0pt;text-indent:-21.0pt'><span lang=EN-US
                                                    style='font-size:12.0pt;font-family:"Times New Roman",serif'>c）<span
        style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; </span></span>与犯罪侦查、起诉、审判和判决执行等直接相关的；</p>
        <p class=ListParagraph1 style='margin-top:0cm;margin-right:0cm;margin-bottom:
7.8pt;margin-left:50.0pt;text-indent:-21.0pt'><span lang=EN-US
                                                    style='font-size:12.0pt;font-family:"Times New Roman",serif'>d）<span
        style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; </span></span>出于维护您或其他个人的生命、财产等重大合法权益但又很难得到您本人同意的；</p>
        <p class=ListParagraph1 style='margin-top:0cm;margin-right:0cm;margin-bottom:
7.8pt;margin-left:50.0pt;text-indent:-21.0pt'><span lang=EN-US
                                                    style='font-size:12.0pt;font-family:"Times New Roman",serif'>e）<span
        style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; </span></span>所收集的信息是您自行向社会公开的或者是从合法公开的渠道（如合法的新闻报道、政府信息公开等渠道）中收集到的；</p>
        <p class=ListParagraph1 style='margin-top:0cm;margin-right:0cm;margin-bottom:
7.8pt;margin-left:50.0pt;text-indent:-21.0pt'><span lang=EN-US
                                                    style='font-size:12.0pt;font-family:"Times New Roman",serif'>f）<span
        style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; </span></span>根据与您签订和履行相关协议或其他书面文件所必需的；</p>
        <p class=ListParagraph1 style='margin-top:0cm;margin-right:0cm;margin-bottom:
7.8pt;margin-left:50.0pt;text-indent:-21.0pt'><span lang=EN-US
                                                    style='font-size:12.0pt;font-family:"Times New Roman",serif'>g）<span
        style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; </span></span>用于维护我们的产品与/或服务的安全稳定运行所必需的，例如发现、处置产品与/或服务的故障；</p>
        <p class=ListParagraph1 style='margin-top:0cm;margin-right:0cm;margin-bottom:
7.8pt;margin-left:50.0pt;text-indent:-21.0pt'><span lang=EN-US
                                                    style='font-size:12.0pt;font-family:"Times New Roman",serif'>h）<span
        style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; </span></span>有权机关的要求、法律法规等规定的其他情形。</p>



      <p class=ListParagraph1 style='margin-top:0cm;margin-right:0cm;margin-bottom:
7.8pt;margin-left:21.0pt;text-indent:-21.0pt'><b><span lang=EN-US
                                                       style='font-size:12.0pt;font-family:"Times New Roman",serif'>四、<span
        style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
</span></span></b><b><span lang=ZH-CN style='font-size:12.0pt;font-family:SimSun'>我们如何共享、转让、公开披露您的个人信息</span></b></p>

      <p class=ListParagraph1 style='margin-top:0cm;margin-right:0cm;margin-bottom:
7.8pt;margin-left:21.0pt;text-indent:-21.0pt'><span lang=EN-US
                                                    style='font-size:12.0pt;font-family:"Times New Roman",serif'>1.<span
        style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; </span></span><span
        lang=ZH-CN style='font-size:12.0pt;font-family:SimSun'>共享</span></p>

      <p class=ListParagraph1 style='margin-top:0cm;margin-right:0cm;margin-bottom:
7.8pt;margin-left:21.0pt;text-indent:0cm'><span lang=ZH-CN style='font-size:
12.0pt;font-family:SimSun'>我们重视对您的个人信息的保护，您的个人信息是我们为您提供产品与/或服务的重要依据和组成部分，对于您的个人信息，我们仅在本隐私政策所述目的和范围内或根据法律法规的要求收集和使用，并严格保密。<b>通常情况下，我们不会与任何公司、组织和个人共享您的个人信息，但以下情况除外：</b></span>
      </p>


<p class=ListParagraph1 style='margin-top:0cm;margin-right:0cm;margin-bottom:
7.8pt;margin-left:21.0pt;text-indent:-21.0pt'><span lang=EN-US
                                                    style='font-size:12.0pt;font-family:"Times New Roman",serif'>1.1<span
        style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; </span></span><span
        lang=ZH-CN
        style='font-size:12.0pt;font-family:SimSun'>事先已获得您的明确授权或同意；</span></p>

        <p class=ListParagraph1 style='margin-top:0cm;margin-right:0cm;margin-bottom:
7.8pt;margin-left:21.0pt;text-indent:-21.0pt'><span lang=EN-US
                                                    style='font-size:12.0pt;font-family:"Times New Roman",serif'>1.2<span
        style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; </span></span><span
        lang=ZH-CN
        style='font-size:12.0pt;font-family:SimSun'>根据适用的法律法规、法律程序、政府的强制命令或司法裁定而需共享您的个人信息；</span></p>

        <p class=ListParagraph1 style='margin-top:0cm;margin-right:0cm;margin-bottom:
7.8pt;margin-left:21.0pt;text-indent:-21.0pt'><span lang=EN-US
                                                    style='font-size:12.0pt;font-family:"Times New Roman",serif'>1.3<span
        style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; </span></span><span
        lang=ZH-CN
        style='font-size:12.0pt;font-family:SimSun'>在法律要求或允许的范围内，为了保护哔哩哔哩及其用户或社会公众的利益、财产或安全免遭损害而有必要提供您的个人信息给第三方；</span></p>

        <p class=ListParagraph1 style='margin-top:0cm;margin-right:0cm;margin-bottom:
7.8pt;margin-left:21.0pt;text-indent:-21.0pt'><span lang=EN-US
                                                    style='font-size:12.0pt;font-family:"Times New Roman",serif'>1.4<span
        style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; </span></span><span
        lang=ZH-CN
        style='font-size:12.0pt;font-family:SimSun'>您的个人信息可能会在我们的关联公司之间共享。我们只会共享必要的个人信息，且这种共享亦受本隐私政策声明目的的约束。关联公司如要改变个人信息的处理目的，将再次征求您的授权同意；</span></p>

        <p class=ListParagraph1 style='margin-top:0cm;margin-right:0cm;margin-bottom:
7.8pt;margin-left:21.0pt;text-indent:-21.0pt'><span lang=EN-US
                                                    style='font-size:12.0pt;font-family:"Times New Roman",serif'>1.5<span
        style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; </span></span><span
        lang=ZH-CN
        style='font-size:12.0pt;font-family:SimSun'><b>为了向您提供更完善、优质的产品和服务，我们的某些服务将由授权合作伙伴提供。我们可能会与合作伙伴共享您的某些个人信息，以提供更好的客户服务和用户体验。我们仅会出于合法、正当、必要、特定、明确的目的共享您的个人信息，并且只会共享提供服务所必要的个人信息。同时，我们会与合作伙伴签署严格的保密协定，要求他们按照我们的说明、本隐私政策以及其他任何相关的保密和安全措施来处理您的个人信息。我们的合作伙伴无权将共享的个人信息用于任何其他用途。如果您拒绝我们的合作伙伴在提供服务时收集为提供服务所必须的个人信息，将可能导致您无法在我们的平台中使用该第三方服务。</b></span></p>

<p class=ListParagraph1 style='margin-top:0cm;margin-right:0cm;margin-bottom:
7.8pt;margin-left:21.0pt;text-indent:-21.0pt'><span lang=EN-US
                                                    style='font-size:12.0pt;font-family:"Times New Roman",serif'>2.<span
        style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; </span></span><span
        lang=ZH-CN style='font-size:12.0pt;font-family:SimSun'>转让</span></p>

      <p class=ListParagraph1 style='margin-top:0cm;margin-right:0cm;margin-bottom:
7.8pt;margin-left:21.0pt;text-indent:0cm'><span lang=ZH-CN style='font-size:
12.0pt;font-family:SimSun'>除非获取您的明确同意，我们不会将您的个人信息转让给任何公司、组织或个人。如果发生合并、收购或破产清算，将可能涉及到个人信息转让，此种情况下我们会要求新的持有您个人信息的公司、组织继续受本隐私政策的约束。如果本隐私政策中约定的个人信息的收集、处理方式发生任何改变，该公司、组织将重新向您征求授权同意。</span>
      </p>

      <p class=ListParagraph1 style='margin-top:0cm;margin-right:0cm;margin-bottom:
7.8pt;margin-left:21.0pt;text-indent:-21.0pt'><span lang=EN-US
                                                    style='font-size:12.0pt;font-family:"Times New Roman",serif'>3.<span
        style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; </span></span><span
        lang=ZH-CN style='font-size:12.0pt;font-family:SimSun'>公开披露</span></p>

      <p class=ListParagraph1 style='margin-top:0cm;margin-right:0cm;margin-bottom:
7.8pt;margin-left:21.0pt;text-indent:0cm'><span lang=ZH-CN style='font-size:
12.0pt;font-family:SimSun'>除非获取您的明确同意，我们不会将您的个人信息转让给任何公司、组织或个人。如果发生合并、收购或破产清算，将可能涉及到个人信息转让，此种情况下我们会要求新的持有您个人信息的公司、组织继续受本隐私政策的约束。如果本隐私政策中约定的个人信息的收集、处理方式发生任何改变，该公司、组织将重新向您征求授权同意。</span>
      </p>
      <p class=ListParagraph1 style='margin-top:0cm;margin-right:0cm;margin-bottom:
7.8pt;margin-left:21.0pt;text-indent:-21.0pt'><span lang=EN-US
                                                    style='font-size:12.0pt;font-family:"Times New Roman",serif'>3.1<span
        style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; </span></span><span
        lang=ZH-CN style='font-size:12.0pt;font-family:SimSun'>公开披露</span></p>

      <p class=ListParagraph1 style='margin-top:0cm;margin-right:0cm;margin-bottom:
7.8pt;margin-left:21.0pt;text-indent:0cm'><span lang=ZH-CN style='font-size:
12.0pt;font-family:SimSun'>公开披露是指向社会或不特定人群发布信息的行为。除了因需要对违规账号、欺诈行为等进行处罚公告、公布中奖/获胜者等名单时脱敏展示相关信息等必要事宜而进行的必要披露外，我们不会对您的个人信息进行公开披露，如具备合理事由确需公开披露的，我们会在公开披露前向您告知公开披露的信息的目的、类型（如涉及您的个人敏感信息的，我们还会向您告知涉及的敏感信息的内容），并在征得您的授权同意后再公开披露，但法律法规另有规定的或本隐私政策另有约定的除外。</span>
      </p>
      <p class=ListParagraph1 style='margin-top:0cm;margin-right:0cm;margin-bottom:
7.8pt;margin-left:21.0pt;text-indent:-21.0pt'><span lang=EN-US
                                                    style='font-size:12.0pt;font-family:"Times New Roman",serif'>3.2<span
        style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; </span></span><span
        lang=ZH-CN style='font-size:12.0pt;font-family:SimSun'>公开披露</span></p>

      <p class=ListParagraph1 style='margin-top:0cm;margin-right:0cm;margin-bottom:
7.8pt;margin-left:21.0pt;text-indent:0cm'><span lang=ZH-CN style='font-size:
12.0pt;font-family:SimSun'>对于公开披露的您的个人信息，我们会在收到公开披露申请后第一时间且审慎审查其正当性、合理性、合法性，并在公开披露时和公开披露后采取最严格个人信息安全保护措施和手段对其进行保护。</span>
      </p>

       <p class=ListParagraph1 style='margin-top:0cm;margin-right:0cm;margin-bottom:
7.8pt;margin-left:21.0pt;text-indent:-21.0pt'><span lang=EN-US
                                                    style='font-size:12.0pt;font-family:"Times New Roman",serif'>4.<span
        style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; </span></span><span
        lang=ZH-CN style='font-size:12.0pt;font-family:SimSun'>共享、转让、公开披露您的个人信息的例外</span></p>

      <p class=ListParagraph1 style='margin-top:0cm;margin-right:0cm;margin-bottom:
7.8pt;margin-left:21.0pt;text-indent:0cm'><span lang=ZH-CN style='font-size:
12.0pt;font-family:SimSun'><b>请您知悉，根据法律法规的规定，在下述情况下，共享、转让、公开披露您的个人信息无需事先征得您的授权同意：</b></span>
      </p>

              <p class=ListParagraph1 style='margin-top:0cm;margin-right:0cm;margin-bottom:
7.8pt;margin-left:21.0pt;text-indent:-21.0pt'><span lang=EN-US
                                                    style='font-size:12.0pt;font-family:"Times New Roman",serif'>4.1<span
        style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; </span></span>与国家安全、国防安全直接相关的；</p>
        <p class=ListParagraph1 style='margin-top:0cm;margin-right:0cm;margin-bottom:
7.8pt;margin-left:21.0pt;text-indent:-21.0pt'><span lang=EN-US
                                                    style='font-size:12.0pt;font-family:"Times New Roman",serif'>4.2<span
        style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; </span></span>与公共安全、公共卫生、重大公共利益直接相关的；</p>

        <p class=ListParagraph1 style='margin-top:0cm;margin-right:0cm;margin-bottom:
7.8pt;margin-left:21.0pt;text-indent:-21.0pt'><span lang=EN-US
                                                    style='font-size:12.0pt;font-family:"Times New Roman",serif'>4.3<span
        style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; </span></span>与犯罪侦查、起诉、审判和判决执行等直接相关的；或根据法律法规的要求、行政机关或公检法等有权机关的要求的；</p>
        <p class=ListParagraph1 style='margin-top:0cm;margin-right:0cm;margin-bottom:
7.8pt;margin-left:21.0pt;text-indent:-21.0pt'><span lang=EN-US
                                                    style='font-size:12.0pt;font-family:"Times New Roman",serif'>4.4<span
        style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; </span></span>出于维护您或其他个人的生命、财产等重大合法权益但又很难得到您本人同意的；</p>
        <p class=ListParagraph1 style='margin-top:0cm;margin-right:0cm;margin-bottom:
7.8pt;margin-left:21.0pt;text-indent:-21.0pt'><span lang=EN-US
                                                    style='font-size:12.0pt;font-family:"Times New Roman",serif'>4.5<span
        style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; </span></span>个人信息是您自行向社会公开的或者是从合法公开的渠道（如合法的新闻报道、政府信息公开等渠道）中收集到的；</p>
        <p class=ListParagraph1 style='margin-top:0cm;margin-right:0cm;margin-bottom:
7.8pt;margin-left:21.0pt;text-indent:-21.0pt'><span lang=EN-US
                                                    style='font-size:12.0pt;font-family:"Times New Roman",serif'>4.6<span
        style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; </span></span>根据与您签订和履行相关协议或其他书面文件所必需的；</p>
        <p class=ListParagraph1 style='margin-top:0cm;margin-right:0cm;margin-bottom:
7.8pt;margin-left:21.0pt;text-indent:-21.0pt'><span lang=EN-US
                                                    style='font-size:12.0pt;font-family:"Times New Roman",serif'>4.7<span
        style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; </span></span>法律法规等规定的其他情形。</p>

      <p class=ListParagraph1 style='margin-top:0cm;margin-right:0cm;margin-bottom:
7.8pt;margin-left:21.0pt;text-indent:-21.0pt'><b><span lang=EN-US
                                                       style='font-size:12.0pt;font-family:"Times New Roman",serif'>五、<span
        style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
</span></span></b><b><span lang=ZH-CN style='font-size:12.0pt;font-family:SimSun'>关于使用Cookie和同类技术</span></b></p>

      <p class=ListParagraph1 style='margin-top:0cm;margin-right:0cm;margin-bottom:
7.8pt;margin-left:21.0pt;text-indent:-21.0pt'><span lang=EN-US
                                                    style='font-size:12.0pt;font-family:"Times New Roman",serif'>1.<span
        style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; </span></span><span
        lang=ZH-CN
        style='font-size:12.0pt;font-family:SimSun'>在您使用我们的产品与/或服务时，我们可能会使用Cookie和同类技术收集您的一些个人信息，包括：您访问网站的习惯、您的浏览信息、您的登录信息，Cookie和同类技术收集该类信息是为了您使用我们的产品与/或服务的必要、简化您重复操作的步骤（如注册、登录）、便于您查看使用历史（如视频观看历史）、向您提供更切合您个人需要的服务内容和您可能更感兴趣的内容、保护您的信息和账号安全性、提升我们的产品和服务等。</span></p>

      <p class=ListParagraph1 style='margin-top:0cm;margin-right:0cm;margin-bottom:
7.8pt;margin-left:21.0pt;text-indent:-21.0pt'><span lang=EN-US
                                                    style='font-size:12.0pt;font-family:"Times New Roman",serif'>2.<span
        style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; </span></span><b><span
        lang=ZH-CN style='font-size:12.0pt;font-family:SimSun'>如果您拒绝我们使用Cookie及同类技术收集和使用您的相关信息，您可在浏览器具备该功能的前提下，通过您的浏览器的设置以管理、（部分/全部）拒绝Cookie与/或同类技术；或删除已经储存在您的计算机、移动设备或其他装置内的Cookie与/或同类技术，从而实现我们无法全部或部分追踪您的个人信息。您如需详细了解如何更改浏览器设置，请具体查看您使用的浏览器的相关设置页面。<b>您理解并知悉：我们的某些产品/服务只能通过使用Cookie或同类技术才可得到实现，如您拒绝使用或删除的，您可能将无法正常使用我们的相关产品与/或服务或无法通过我们的产品与/或服务获得最佳的服务体验，同时也可能会对您的信息保护和账号安全性造成一定的影响。</b></span></b></p>

      <p class=ListParagraph1 style='margin-top:0cm;margin-right:0cm;margin-bottom:
7.8pt;margin-left:21.0pt;text-indent:-21.0pt'><b><span lang=EN-US
                                                       style='font-size:12.0pt;font-family:"Times New Roman",serif'>六、<span
        style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
</span></span></b><b><span lang=ZH-CN style='font-size:12.0pt;font-family:SimSun'>我们对您个人信息的存储与保护</span></b></p>

      <p class=ListParagraph1 style='margin-top:0cm;margin-right:0cm;margin-bottom:
7.8pt;margin-left:21.0pt;text-indent:-21.0pt'><span lang=EN-US
                                                    style='font-size:12.0pt;font-family:"Times New Roman",serif'>1.<span
        style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; </span></span><span
        lang=ZH-CN style='font-size:12.0pt;font-family:SimSun;color:black;background:
white'>信息存储</span>
      </p>
      <p class=ListParagraph1 style='margin-top:0cm;margin-right:0cm;margin-bottom:
7.8pt;margin-left:21.0pt;text-indent:-21.0pt'><span lang=EN-US
                                                    style='font-size:12.0pt;font-family:"Times New Roman",serif'>1.1<span
        style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; </span></span><span
        lang=ZH-CN style='font-size:12.0pt;font-family:SimSun;color:black;background:
white'><b>存储地点：我们依照法律法规的规定，仅会将收集到的有关您的个人信息存储于中华人民共和国境内。目前我们暂时不存在跨境存储您的个人信息或向境外提供个人信息的场景。如果确有必要进行数据的跨境传输，我们会单独向您明确告知（包括数据出境的目的、接收方、使用方式与范围、使用内容、安全保障措施、安全风险等），并征得您的授权同意，我们会确保数据接收方有充足的数据保护能力来保护您的个人信息。</b></span>
      </p>
      <p class=ListParagraph1 style='margin-top:0cm;margin-right:0cm;margin-bottom:
7.8pt;margin-left:21.0pt;text-indent:-21.0pt'><span lang=EN-US
                                                    style='font-size:12.0pt;font-family:"Times New Roman",serif'>1.2<span
        style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; </span></span><span
        lang=ZH-CN style='font-size:12.0pt;font-family:SimSun;color:black;background:
white'><b>存储期限：我们在为您提供满足产品和服务目的所必需且最短的期间内保留您的个人信息，例如：当您使用我们的注册及会员功能时，我们需要收集您的手机号码，且在您提供后并在您使用该功能期间，我们需要持续保存您的手机号码，以向您正常提供该功能、保障您的账号和系统安全。此外，我们或对您的相关信息保存至相关法律所规定的必要期限。</b></span>
      </p>
      <p class=ListParagraph1 style='margin-top:0cm;margin-right:0cm;margin-bottom:
7.8pt;margin-left:21.0pt;text-indent:-21.0pt'><span lang=EN-US
                                                    style='font-size:12.0pt;font-family:"Times New Roman",serif'>1.3<span
        style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; </span></span><span
        lang=ZH-CN style='font-size:12.0pt;font-family:SimSun;color:black;background:
white'><b>在超出上述存储期限后，我们会对您的个人信息进行删除或匿名化处理。</b></span>
      </p>


      <p class=ListParagraph1 style='margin-top:0cm;margin-right:0cm;margin-bottom:
7.8pt;margin-left:21.0pt;text-indent:-21.0pt'><span lang=EN-US
                                                    style='font-size:12.0pt;font-family:"Times New Roman",serif'>2.<span
        style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; </span></span><span
        lang=ZH-CN style='font-size:12.0pt;font-family:SimSun;color:black;background:
white'>信息保护</span>
      </p>
      <p class=ListParagraph1 style='margin-top:0cm;margin-right:0cm;margin-bottom:
7.8pt;margin-left:21.0pt;text-indent:-21.0pt'><span lang=EN-US
                                                    style='font-size:12.0pt;font-family:"Times New Roman",serif'>2.1<span
        style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; </span></span><span
        lang=ZH-CN style='font-size:12.0pt;font-family:SimSun;color:black;background:
white'>您的个人信息安全对于我们至关重要。我们将严格遵守相关法律法规，采取业内认可的合理可行的措施，保护您的个人信息。防止信息遭到未经授权的访问、披露、使用、修改，避免信息损坏或丢失。</span>
      </p>
      <p class=ListParagraph1 style='margin-top:0cm;margin-right:0cm;margin-bottom:
7.8pt;margin-left:21.0pt;text-indent:-21.0pt'><span lang=EN-US
                                                    style='font-size:12.0pt;font-family:"Times New Roman",serif'>2.2<span
        style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; </span></span><span
        lang=ZH-CN style='font-size:12.0pt;font-family:SimSun;color:black;background:
white'><b>我们使用符合业界标准的安全防护措施保护您提供的个人信息，防止数据遭到未经授权的访问、公开披露、使用、修改，防止数据发生损坏或丢失。我们会采取一切合理可行的措施，保护您的个人信息。例如使用SSL对数据进行加密保护；我们已建立访问控制机制，确保只有授权人员才可以访问个人信息；我们不时的举办安全和隐私保护培训课程，加强员工对于保护个人信息重要性的认识。</b></span>
      </p>
      <p class=ListParagraph1 style='margin-top:0cm;margin-right:0cm;margin-bottom:
7.8pt;margin-left:21.0pt;text-indent:-21.0pt'><span lang=EN-US
                                                    style='font-size:12.0pt;font-family:"Times New Roman",serif'>2.3<span
        style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; </span></span><span
        lang=ZH-CN style='font-size:12.0pt;font-family:SimSun;color:black;background:
white'>为防止安全事故的发生，我们成立了专门的数据安全部门并制定了妥善的预警机制和应急预案。一旦发生个人信息安全事件，我们将按照法律法规的要求，及时向您告知：安全事件的基本情况和可能的影响、我们已采取或将要采取的处置措施、您可自主防范和降低风险的建议和对您的补救措施，并立即启动应急预案，力求将损失最小化。我们将及时将事件相关情况以电话、推送通知等方式告知您。</span>
      </p>
      <p class=ListParagraph1 style='margin-top:0cm;margin-right:0cm;margin-bottom:
7.8pt;margin-left:21.0pt;text-indent:-21.0pt'><span lang=EN-US
                                                    style='font-size:12.0pt;font-family:"Times New Roman",serif'>2.4<span
        style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; </span></span><span
        lang=ZH-CN style='font-size:12.0pt;font-family:SimSun;color:black;background:
white'>同时，我们还设立哔哩哔哩安全应急响应中心（https://security.bilibili.com），由专业的安全技术和运营团队负责维护，便于及时有效的响应、处置各类安全漏洞和突发事件，联合相关部门进行安全事件溯源和打击。</span>
      </p>

<p class=ListParagraph1 style='margin-top:0cm;margin-right:0cm;margin-bottom:
7.8pt;margin-left:21.0pt;text-indent:-21.0pt'><b><span lang=EN-US
                                                       style='font-size:12.0pt;font-family:"Times New Roman",serif'>七、<span
        style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
</span></span></b><b><span lang=ZH-CN style='font-size:12.0pt;font-family:SimSun'>您管理个人信息的权利</span></b></p>

<p class=ListParagraph1 style='margin-top:0cm;margin-right:0cm;margin-bottom:
7.8pt;margin-left:21.0pt;text-indent:-21.0pt'><span><b>我们理解您对个人信息的关注，并尽全力确保您对于自己个人信息访问、更正、删除以及撤回授权的权利，以使您拥有充分的能力保障您的隐私和安全。</b></span>
      </p>
<p class=ListParagraph1 style='margin-top:0cm;margin-right:0cm;margin-bottom:
7.8pt;margin-left:21.0pt;text-indent:-21.0pt'><span><b>您的权利包括：</b></span>
      </p>
      <p class=ListParagraph1 style='margin-top:0cm;margin-right:0cm;margin-bottom:
7.8pt;margin-left:21.0pt;text-indent:-21.0pt'><span lang=EN-US
                                                       style='font-size:12.0pt;font-family:"Times New Roman",serif'>1.<span
        style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; </span></span><span>您有权访问您的个人信息</span>
      </p>
       <p class=ListParagraph1 style='margin-top:0cm;margin-right:0cm;margin-bottom:
7.8pt;margin-left:21.0pt;text-indent:-21.0pt'><b></b><span>您可以按照我们提供的产品和服务的相关说明（或设置），对您已提供给我们的相关个人信息进行查阅。</span>
      </p>

      <p class=ListParagraph1 style='margin-top:0cm;margin-right:0cm;margin-bottom:
7.8pt;margin-left:21.0pt;text-indent:-21.0pt'><span lang=EN-US
                                                       style='font-size:12.0pt;font-family:"Times New Roman",serif'>a.<span
        style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; </span></span><span>账号信息：开发者可以随时访问开放平台管理中心，以访问开发者账号中的资质信息，包括账号信息、资质认证信息、应用信息等；</span>
      </p>

<p class=ListParagraph1 style='margin-top:0cm;margin-right:0cm;margin-bottom:
7.8pt;margin-left:21.0pt;text-indent:-21.0pt'><span lang=EN-US
                                                       style='font-size:12.0pt;font-family:"Times New Roman",serif'>b.<span
        style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; </span></span><span>授权信息：UP主可以随时查阅绑定的开发者信息以及在哔哩哔哩APP的授权管理页面查阅开放的权限及个人信息；开发者可以随时查阅关联应用以及关联UP主等；</span>
      </p>
      <p class=ListParagraph1 style='margin-top:0cm;margin-right:0cm;margin-bottom:
7.8pt;margin-left:21.0pt;text-indent:-21.0pt'><span lang=EN-US
                                                       style='font-size:12.0pt;font-family:"Times New Roman",serif'>c.<span
        style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; </span></span><span>其他信息：如您在访问过程中遇到操作问题或需获取其他前述无法获知的个人信息内容，您可通过本隐私政策提供的方式联系我们。</span>
      </p>

      <p class=ListParagraph1 style='margin-top:0cm;margin-right:0cm;margin-bottom:
7.8pt;margin-left:21.0pt;text-indent:-21.0pt'><span lang=EN-US
                                                       style='font-size:12.0pt;font-family:"Times New Roman",serif'>2.<span
        style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; </span></span><b><span
        lang=ZH-CN style='font-size:12.0pt;font-family:SimSun'>您有权更正/修改您的个人信息</span></b>
      </p>
      <p class=ListParagraph1 style='margin-top:0cm;margin-right:0cm;margin-bottom:
7.8pt;margin-left:21.0pt;text-indent:-21.0pt'><b></b><span>当您发现您提供给我们的个人信息存在登记错误、不完整或有更新的，经过对您身份的验证，且更正/修改不影响信息的客观性和准确性的情况下，您有权对错误或不完整的信息作出更正或修改，或在特定情况下，尤其是数据错误时，通过我们公布的反馈与报错等措施将您的更正/修改申请提交给我们，要求我们更正或修改您的数据，但法律法规另有规定的除外。但出于安全性和身份识别的考虑，您可能无法修改注册时提交的某些初始注册信息。</span>
      </p>


      <p class=ListParagraph1 style='margin-top:0cm;margin-right:0cm;margin-bottom:
7.8pt;margin-left:21.0pt;text-indent:-21.0pt'><span lang=EN-US
                                                       style='font-size:12.0pt;font-family:"Times New Roman",serif'>3.<span
        style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; </span></span><b><span
        lang=ZH-CN style='font-size:12.0pt;font-family:SimSun'>您有权删除您的个人信息</span></b>
      </p>

      <p class=ListParagraph1 style='margin-top:0cm;margin-right:0cm;margin-bottom:
7.8pt;margin-left:21.0pt;text-indent:-21.0pt'><span lang=EN-US
                                                       style='font-size:12.0pt;font-family:"Times New Roman",serif'>3.1<span
        style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; </span></span><span
        lang=ZH-CN style='font-size:12.0pt;font-family:SimSun'>当发生以下情况时，您可以直接要求我们删除您的个人信息，但已做匿名化处理或法律法规另有规定的除外：</span></p>

        <p class=ListParagraph1 style='margin-top:0cm;margin-right:0cm;margin-bottom:
7.8pt;margin-left:50.0pt;text-indent:-21.0pt'><span lang=EN-US
                                                    style='font-size:12.0pt;font-family:"Times New Roman",serif'>a）<span
        style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; </span></span>当我们处理个人信息的行为违反法律法规时；</p>
        <p class=ListParagraph1 style='margin-top:0cm;margin-right:0cm;margin-bottom:
7.8pt;margin-left:50.0pt;text-indent:-21.0pt'><span lang=EN-US
                                                    style='font-size:12.0pt;font-family:"Times New Roman",serif'>b）<span
        style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; </span></span>当我们收集、使用您的个人信息，却未征得您的同意时；</p>
        <p class=ListParagraph1 style='margin-top:0cm;margin-right:0cm;margin-bottom:
7.8pt;margin-left:50.0pt;text-indent:-21.0pt'><span lang=EN-US
                                                    style='font-size:12.0pt;font-family:"Times New Roman",serif'>c）<span
        style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; </span></span>当我们处理个人信息的行为违反了与您的约定时；</p>
        <p class=ListParagraph1 style='margin-top:0cm;margin-right:0cm;margin-bottom:
7.8pt;margin-left:50.0pt;text-indent:-21.0pt'><span lang=EN-US
                                                    style='font-size:12.0pt;font-family:"Times New Roman",serif'>d）<span
        style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; </span></span>当您注销了哔哩哔哩账号和/或开发者账号时；</p>

 <p class=ListParagraph1 style='margin-top:0cm;margin-right:0cm;margin-bottom:
7.8pt;margin-left:50.0pt;text-indent:-21.0pt'><span lang=EN-US
                                                    style='font-size:12.0pt;font-family:"Times New Roman",serif'>e）<span
        style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; </span></span>当我们终止服务及运营时。</p>

<p class=ListParagraph1 style='margin-top:0cm;margin-right:0cm;margin-bottom:
7.8pt;margin-left:21.0pt;text-indent:-21.0pt'><span lang=EN-US
                                                       style='font-size:12.0pt;font-family:"Times New Roman",serif'>4.<span
        style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; </span></span><b><span
        lang=ZH-CN style='font-size:12.0pt;font-family:SimSun'>您有权撤回您对个人信息的授权</span></b>
      </p>
      <p class=ListParagraph1 style='margin-top:0cm;margin-right:0cm;margin-bottom:
7.8pt;margin-left:21.0pt;text-indent:-21.0pt'><b></b><span>如前文所述，我们提供的产品和服务的部分功能需要获得您的相关授权（包括信息披露、稿件管理权限等，具体以产品实际获取的功能为准）。您可以在授权后随时撤回（或停止）对该权限的继续授权。UP主可以通过哔哩哔哩APP中的“<b>【我的—设置—安全隐私—授权管理】</b>”来关闭授权；开发者无法单方撤回对关联UP主披露必要信息的授权，但可以通过注销开发者账号或注销关联应用的方式，永久撤回后续新增的授权。</span>
      </p>

      <p class=ListParagraph1 style='margin-top:0cm;margin-right:0cm;margin-bottom:
7.8pt;margin-left:21.0pt;text-indent:-21.0pt'><b></b><span>您需理解，当您撤回授权后，我们无法继续为您提供撤回授权所对应的特定功能和/或服务。但您撤回授权的决定，不会影响此前基于您的授权而开展的个人信息处理。</span>
      </p>

      <p class=ListParagraph1 style='margin-top:0cm;margin-right:0cm;margin-bottom:
7.8pt;margin-left:21.0pt;text-indent:-21.0pt'><span lang=EN-US
                                                       style='font-size:12.0pt;font-family:"Times New Roman",serif'>5.<span
        style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; </span></span><b><span
        lang=ZH-CN style='font-size:12.0pt;font-family:SimSun'>您有权注销您的账号</span></b>
      </p>
      <p class=ListParagraph1 style='margin-top:0cm;margin-right:0cm;margin-bottom:
7.8pt;margin-left:21.0pt;text-indent:-21.0pt'><b></b><span>您可以通过在线申请注销或客服或通过其他我们公示的方式申请注销您的账号。<b>当您注销账号后，您将无法再以该账号登录和使用我们的产品与服务；且该账号在哔哩哔哩及旗下的其他产品与服务使用期间已产生的但未消耗完毕的权益及未来的逾期利益等全部权益将被清除；该账号下的内容、信息、数据、记录等将会被删除或匿名化处理（但法律法规另有规定或监管部门另有要求的除外，如依据《中华人民共和国网络安全法》规定，您的网络操作日志将至少保留六个月的时间）；哔哩哔哩账号注销完成后，将无法恢复。</b></span>
      </p>
      <p class=ListParagraph1 style='margin-top:0cm;margin-right:0cm;margin-bottom:
7.8pt;margin-left:21.0pt;text-indent:-21.0pt'><b></b><span>更多关于哔哩哔哩账号注销的流程、条件等事项请详见<a href='https://www.bilibili.com/blackboard/activity-2qx0xFPl.html'>《账号注销协议》</a>。</span>
      </p>

      <p class=ListParagraph1 style='margin-top:0cm;margin-right:0cm;margin-bottom:
7.8pt;margin-left:21.0pt;text-indent:-21.0pt'><b><span lang=EN-US
                                                       style='font-size:12.0pt;font-family:"Times New Roman",serif'>八、<span
        style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
</span></span></b><b><span lang=ZH-CN style='font-size:12.0pt;font-family:SimSun'>联系我们</span></b></p>

      <p class=ListParagraph1 style='margin-top:0cm;margin-right:0cm;margin-bottom:
7.8pt;margin-left:21.0pt;text-indent:-21.0pt'><span lang=EN-US
                                                       style='font-size:12.0pt;font-family:"Times New Roman",serif'>1.<span
        style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; </span></span><span
        lang=ZH-CN style='font-size:12.0pt;font-family:SimSun'>如您对本隐私政策的内容或使用我们的服务时遇到的与隐私保护相关的事宜有任何疑问或进行咨询或投诉时，您均可以通过如下任一方式与我们取得联系：</span>
      </p>
      <p class=ListParagraph1 style='margin-top:0cm;margin-right:0cm;margin-bottom:
7.8pt;margin-left:21.0pt;text-indent:-21.0pt'><span lang=EN-US
                                                       style='font-size:12.0pt;font-family:"Times New Roman",serif'>1.1.<span
        style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; </span></span><span
        lang=ZH-CN style='font-size:12.0pt;font-family:SimSun'>您可找到开放平台上产品功能页面中帮助中心与其联系或者在线提交反馈意见；</span>
      </p>
      <p class=ListParagraph1 style='margin-top:0cm;margin-right:0cm;margin-bottom:
7.8pt;margin-left:21.0pt;text-indent:-21.0pt'><span lang=EN-US
                                                       style='font-size:12.0pt;font-family:"Times New Roman",serif'>1.2<span
        style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; </span></span><span
        lang=ZH-CN style='font-size:12.0pt;font-family:SimSun'>您可以向我们开通的【openplatform-feedback@bilibili.com】客服邮箱发送邮件与我们联系；</span>
      </p>
      <p class=ListParagraph1 style='margin-top:0cm;margin-right:0cm;margin-bottom:
7.8pt;margin-left:21.0pt;text-indent:-21.0pt'><span lang=EN-US
                                                       style='font-size:12.0pt;font-family:"Times New Roman",serif'>1.3<span
        style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; </span></span><span
        lang=ZH-CN style='font-size:12.0pt;font-family:SimSun'>您可以写信至：上海市杨浦区政立路485号国正中心3号楼 法务部（收）；邮编：200082。</span>
      </p>

      <p class=ListParagraph1 style='margin-top:0cm;margin-right:0cm;margin-bottom:
7.8pt;margin-left:21.0pt;text-indent:-21.0pt'><span lang=EN-US
                                                       style='font-size:12.0pt;font-family:"Times New Roman",serif'>2<span
        style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; </span></span><span
        lang=ZH-CN style='font-size:12.0pt;font-family:SimSun'> 我们会在收到您的意见及建议后，并在验证您的用户身份后的15个工作日内尽快向您回复。<b>此外，您理解并知悉，在与个人信息有关的如下情形下，我们将无法回复您的请求：</b></span>
      </p>

              <p class=ListParagraph1 style='margin-top:0cm;margin-right:0cm;margin-bottom:
7.8pt;margin-left:21.0pt;text-indent:-21.0pt'><span lang=EN-US
                                                    style='font-size:12.0pt;font-family:"Times New Roman",serif'>2.1<span
        style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; </span></span>与国家安全、国防安全直接相关的；</p>
        <p class=ListParagraph1 style='margin-top:0cm;margin-right:0cm;margin-bottom:
7.8pt;margin-left:21.0pt;text-indent:-21.0pt'><span lang=EN-US
                                                    style='font-size:12.0pt;font-family:"Times New Roman",serif'>2.2<span
        style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; </span></span>与公共安全、公共卫生、重大公共利益直接相关的；</p>

        <p class=ListParagraph1 style='margin-top:0cm;margin-right:0cm;margin-bottom:
7.8pt;margin-left:21.0pt;text-indent:-21.0pt'><span lang=EN-US
                                                    style='font-size:12.0pt;font-family:"Times New Roman",serif'>2.3<span
        style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; </span></span>与犯罪侦查、起诉、审判和判决执行等直接相关的；或根据法律法规的要求、行政机关或公检法等有权机关的要求的；</p>
        <p class=ListParagraph1 style='margin-top:0cm;margin-right:0cm;margin-bottom:
7.8pt;margin-left:21.0pt;text-indent:-21.0pt'><span lang=EN-US
                                                    style='font-size:12.0pt;font-family:"Times New Roman",serif'>2.4<span
        style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; </span></span>出于维护您或其他个人的生命、财产等重大合法权益但又很难得到您本人同意的；</p>
        <p class=ListParagraph1 style='margin-top:0cm;margin-right:0cm;margin-bottom:
7.8pt;margin-left:21.0pt;text-indent:-21.0pt'><span lang=EN-US
                                                    style='font-size:12.0pt;font-family:"Times New Roman",serif'>2.5<span
        style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; </span></span>个人信息是您自行向社会公开的或者是从合法公开的渠道（如合法的新闻报道、政府信息公开等渠道）中收集到的；</p>
        <p class=ListParagraph1 style='margin-top:0cm;margin-right:0cm;margin-bottom:
7.8pt;margin-left:21.0pt;text-indent:-21.0pt'><span lang=EN-US
                                                    style='font-size:12.0pt;font-family:"Times New Roman",serif'>2.6<span
        style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; </span></span>根据与您签订和履行相关协议或其他书面文件所必需的；</p>
        <p class=ListParagraph1 style='margin-top:0cm;margin-right:0cm;margin-bottom:
7.8pt;margin-left:21.0pt;text-indent:-21.0pt'><span lang=EN-US
                                                    style='font-size:12.0pt;font-family:"Times New Roman",serif'>2.7<span
        style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; </span></span>法律法规等规定的其他情形。</p>

     
      <p class=ListParagraph1 style='margin-top:0cm;margin-right:0cm;margin-bottom:
7.8pt;margin-left:21.0pt;text-indent:-21.0pt'><b><span lang=EN-US
                                                       style='font-size:12.0pt;font-family:"Times New Roman",serif'>九、<span
        style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp; </span></span></b><b><span
        lang=ZH-CN style='font-size:12.0pt;font-family:SimSun'>本隐私政策如何更新</span></b></p>

      <p class=ListParagraph1 style='margin-top:0cm;margin-right:0cm;margin-bottom:
7.8pt;margin-left:21.0pt;text-indent:-21.0pt'><span lang=EN-US
                                                       style='font-size:12.0pt;font-family:"Times New Roman",serif'>1.<span
        style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; </span></span><span
        lang=ZH-CN
        style='font-size:12.0pt;font-family:SimSun'>为了给您提供更好的服务，我们会根据产品的更新情况及法律法规的相关要求更新本隐私政策的条款，该等更新构成本隐私政策的一部分。未经您明确同意，我们不会削减您按照本隐私政策所应享有的权利。<b>如该等更新造成您在本隐私政策下权利的实质减少或重大变更，我们将在本隐私政策生效前通过在显著位置提示或向您发送推送消息或以其他方式通知您，若您继续使用我们的服务，即表示您充分阅读、理解并同意受经修订的隐私政策约束。</b></span>
      </p>

      <p class=ListParagraph1 style='margin-top:0cm;margin-right:0cm;margin-bottom:
7.8pt;margin-left:21.0pt;text-indent:-21.0pt'><span lang=EN-US
                                                    style='font-size:12.0pt;font-family:"Times New Roman",serif'>2.<span
        style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; </span></span><span
        lang=ZH-CN style='font-size:12.0pt;font-family:SimSun'>重大变更包括但不限于：</span>
      </p>
      <p class=ListParagraph1 style='margin-top:0cm;margin-right:0cm;margin-bottom:
7.8pt;margin-left:21.0pt;text-indent:-21.0pt'><span lang=EN-US
                                                    style='font-size:12.0pt;font-family:"Times New Roman",serif'>2.1<span
        style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; </span></span><span
        lang=ZH-CN style='font-size:12.0pt;font-family:SimSun'>我们的服务模式发生重大变化。如处理个人信息的目的、处理的个人信息类型、个人信息的使用方式等；</span>
      </p>
      <p class=ListParagraph1 style='margin-top:0cm;margin-right:0cm;margin-bottom:
7.8pt;margin-left:21.0pt;text-indent:-21.0pt'><span lang=EN-US
                                                    style='font-size:12.0pt;font-family:"Times New Roman",serif'>2.2<span
        style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; </span></span><span
        lang=ZH-CN style='font-size:12.0pt;font-family:SimSun'>我们在所有权结构、组织架构等方面发生重大变化。如业务调整、破产并购等引起的所有者变更等；</span>
      </p>
      <p class=ListParagraph1 style='margin-top:0cm;margin-right:0cm;margin-bottom:
7.8pt;margin-left:21.0pt;text-indent:-21.0pt'><span lang=EN-US
                                                    style='font-size:12.0pt;font-family:"Times New Roman",serif'>2.3<span
        style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; </span></span><span
        lang=ZH-CN style='font-size:12.0pt;font-family:SimSun'>个人信息共享、转让或公开披露的主要对象发生变化；</span>
      </p>
      <p class=ListParagraph1 style='margin-top:0cm;margin-right:0cm;margin-bottom:
7.8pt;margin-left:21.0pt;text-indent:-21.0pt'><span lang=EN-US
                                                    style='font-size:12.0pt;font-family:"Times New Roman",serif'>2.4<span
        style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; </span></span><span
        lang=ZH-CN style='font-size:12.0pt;font-family:SimSun'>您参与个人信息处理方面的权利及其行使方式发生重大变化；</span>
      </p>
      <p class=ListParagraph1 style='margin-top:0cm;margin-right:0cm;margin-bottom:
7.8pt;margin-left:21.0pt;text-indent:-21.0pt'><span lang=EN-US
                                                    style='font-size:12.0pt;font-family:"Times New Roman",serif'>2.5<span
        style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; </span></span><span
        lang=ZH-CN style='font-size:12.0pt;font-family:SimSun'>我们负责处理个人信息安全的责任部门、联络方式及投诉渠道发生变化；</span>
      </p>
      <p class=ListParagraph1 style='margin-top:0cm;margin-right:0cm;margin-bottom:
7.8pt;margin-left:21.0pt;text-indent:-21.0pt'><span lang=EN-US
                                                    style='font-size:12.0pt;font-family:"Times New Roman",serif'>2.6<span
        style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; </span></span><span
        lang=ZH-CN style='font-size:12.0pt;font-family:SimSun'>个人信息安全影响评估报告表明存在高风险时</span>
      </p>

          <p class=ListParagraph1 style='margin-top:0cm;margin-right:0cm;margin-bottom:
7.8pt;margin-left:21.0pt;text-indent:-21.0pt'><b><span lang=EN-US
                                                       style='font-size:12.0pt;font-family:"Times New Roman",serif'>十、<span
        style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp; </span></span></b><b><span
        lang=ZH-CN style='font-size:12.0pt;font-family:SimSun'>争议解决</span></b></p>

      <p class=ListParagraph1 style='margin-top:0cm;margin-right:0cm;margin-bottom:
7.8pt;margin-left:21.0pt;text-indent:-21.0pt'><span lang=EN-US
                                                       style='font-size:12.0pt;font-family:"Times New Roman",serif'>1.<span
        style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; </span></span><span
        lang=ZH-CN
        style='font-size:12.0pt;font-family:SimSun'><b>本隐私政策的解释及争议解决均应适用中华人民共和国大陆地区法律。任何因本隐私政策以及我们处理您个人信息事宜引起的争议，您同意向上海仲裁委员会提起仲裁解决；该仲裁一裁终局，对双方均具有法律约束力。</b></span>
      </p>
      <p class=ListParagraph1 style='margin-top:0cm;margin-right:0cm;margin-bottom:
7.8pt;margin-left:21.0pt;text-indent:-21.0pt'><span lang=EN-US
                                                       style='font-size:12.0pt;font-family:"Times New Roman",serif'>2.<span
        style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; </span></span><span
        lang=ZH-CN
        style='font-size:12.0pt;font-family:SimSun'>如果您认为我们处理个人信息的行为损害了您的合法权益，您也可以选择向有关政府部门进行反映。</span>
      </p>
      <p class=ListParagraph1 style='margin-top:0cm;margin-right:0cm;margin-bottom:
7.8pt;margin-left:21.0pt;text-indent:-21.0pt'><span lang=EN-US
                                                       style='font-size:12.0pt;font-family:"Times New Roman",serif'>3.<span
        style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; </span></span><span
        lang=ZH-CN
        style='font-size:12.0pt;font-family:SimSun'>本隐私政策的标题仅为方便及阅读而设，并不影响正文其中任何规定的含义或解释。</span>
      </p>
      
    </div>`